/*
 * @Author: chengyan
 * @Date: 2021-10-21 11:04:13
 * @LastEditTime: 2022-03-18 18:41:47
 * @LastEditors: FeBro
 * @Description: http请求相关配置
 */
// 环境变量
const { NODE_ENV } = process.env

// 线上环境域名
// 测试: 'hissct.mobimedical.cn'
// 预发: 'debug.jksc.mobimedical.cn'
// 正式: 'jksc.scwjxx.cn'

// 匹配接口地址
const testURI = '/testApi' // testApi为本地代理, 参见：根目录下/config/index 的 proxyTable设置
const URI = (NODE_ENV === 'development' ? testURI : '') + '/api/v1'

export default {
    baseURL: URI,
    timeout: 20000,
    withCredentials: !NODE_ENV === 'development'
}


// WEBPACK FOOTER //
// ./src/config/request.js